import mixin_calculators from "@/calculators/mixin.calculators.js";
import mixin from "@/mixin/index.js";
const changeVariableDisplay = mixin_calculators.changeVariableDisplay;
const invalidAnimal = mixin_calculators.invalidAnimal;
const getNumber = mixin.methods._getNumber;
const _formatAndRoundNumber = mixin.methods._formatAndRoundNumber;

const BODY_SCORE_ITEMS = [
    '1 | Emaciado',
    '2 | Muito Magro',
    '3 | Magro',
    '4 | Discreto Subpeso',
    '5 | Ideal',
    '6 | Discreto Sobrepeso',
    '7 | Sobrepeso',
    '8 | Obeso',
    '9 | Obesidade Mórbida',
];
const BODY_SCORE_FACTORS = {
    0: [
        { score: 1, factor: 1.4 },
        { score: 2, factor: 1.3 },
        { score: 2, factor: 1.4 },
        { score: 3, factor: 1.2 },
        { score: 3, factor: 1.3 },
        { score: 4, factor: 1.1 },
        { score: 4, factor: 1.15 },
        { score: 5, factor: 1 },
        { score: 6, factor: 0.9 },
        { score: 6, factor: 0.85 },
        { score: 7, factor: 0.8 },
        { score: 7, factor: 0.7 },
        { score: 8, factor: 0.7 },
        { score: 8, factor: 0.55 },
        { score: 9, factor: 0.55 },
    ],
    1: [
        { score: 1, factor: 1.4 },
        { score: 2, factor: 1.3 },
        { score: 2, factor: 1.4 },
        { score: 3, factor: 1.2 },
        { score: 3, factor: 1.3 },
        { score: 4, factor: 1.1 },
        { score: 4, factor: 1.15 },
        { score: 5, factor: 1 },
        { score: 6, factor: 0.9 },
        { score: 6, factor: 0.85 },
        { score: 7, factor: 0.8 },
        { score: 7, factor: 0.7 },
        { score: 8, factor: 0.7 },
        { score: 8, factor: 0.6 },
        { score: 9, factor: 0.6 },
    ]
}
const DOG_LACTATION_WEEK = [
    'Primeira Semana',
    'Segunda Semana',
    'Terceira Semana',
    'Quarta Semana em Diante',
];
const CAT_LACTATION_WEEK = [
    'Primeira e Segunda Semana',
    'Terceira e Quarta Semana',
    'Quinta Semana',
    'Sexta Semana',
    'Sétima semana em diante',
];
const CAT_PUPPIES_NUMBER = [
    'Menos de 3 filhotes',
    'De 3 a 4 filhotes',
    'Mais de 4 filhotes',
];
const VARIABLES = [
    {
        name: 'Selecione o paciente',
        type: 'select-animal',
        placeholder: 'Selecione',
        id: 'animal',
        items: [
            'dog',
            'cat',
        ],
        change: function (val) {
            changeVariableDisplay("dogLifeStage", val != 0);
            changeVariableDisplay("dogPuppiesNumber");
            changeVariableDisplay("dogLactationWeek");
            changeVariableDisplay("catLifeStage", val == 0);
            changeVariableDisplay("catPuppiesNumber");
            changeVariableDisplay("catLactationWeek");
        },
        reset: [
            "dogLifeStage",
            "dogPuppiesNumber",
            "dogLactationWeek",
            "catLifeStage",
            "catPuppiesNumber",
            "catLactationWeek"
        ],
        default: 0
    },
    {
        name: 'Peso do paciente (kg)',
        type: 'number',
        placeholder: 'Insira o Peso do Paciente',
        id: 'weight',
        default: 0,
        suffix: 'kg'
    },
    {
        name: 'Selecione o Escore Corporal do Paciente',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'bodyScore',
        items: BODY_SCORE_ITEMS,
        default: null,
    },
    // DOGS
    {
        name: 'Selecione a Fase da Vida do Paciente',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'dogLifeStage',
        change: function (val) {
            changeVariableDisplay("dogPuppiesNumber", val != 'Lactação');
            changeVariableDisplay("dogLactationWeek", val != 'Lactação');
        },
        items: [
            { header: "Filhotes" },
            "Neonatos",
            "Até 50% do Peso Quando Adulto",
            "De 50 a 80% do Peso Quando Adulto",
            "80 a 100% do Peso Quando Adulto",
            { header: "Adulto" },
            "Perda de Peso",
            "Adulto Suscetível a Obesidade",
            "Sedentário ou Baixa Atividade (<1h/dia)",
            "Atividade Moderada de Baixo Impacto (1 – 3 h/dia)",
            "Atividade Moderada de Alto Impacto (1 – 3 h/dia)",
            "Alta Atividade (3 – 6 h/dia)",
            "Alta Atividade sob Condições Extremas (ex: corridas de trenó)",
            "Dogue Alemão",
            "Terra-nova (Newfoundland)",
            { header: "Gestação" },
            "Primeiras 4 semanas de Gestação",
            "Últimas 5 semanas de Gestação",
            { header: "Lactação" },
            "Lactação",
        ],
        default: null,
    },
    {
        name: 'Número de Filhotes',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'dogPuppiesNumber',
        items: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
        ],
        default: null,
    },
    {
        name: 'Semana de Lactação',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'dogLactationWeek',
        items: DOG_LACTATION_WEEK,
        default: null,
    },
    // CATS
    {
        name: 'Selecione a Fase da Vida do Paciente',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'catLifeStage',
        change: function (val) {
            changeVariableDisplay("catPuppiesNumber", val != 'Lactação');
            changeVariableDisplay("catLactationWeek", val != 'Lactação');
        },
        items: [
            { header: "Filhotes" },
            "Até 4 meses de idade",
            "4 a 9 meses de idade",
            "9 a 12 meses de idade",
            { header: "Adultos" },
            "Castrado, Sedentário, Estrito Intradomiciliar",
            "Gato Ativo",
            { header: "Gestação" },
            "Gestação",
            { header: "Lactação" },
            "Lactação",
        ],
        default: null,
    },
    {
        name: 'Número de Filhotes',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'catPuppiesNumber',
        items: CAT_PUPPIES_NUMBER,
        default: null,
    },
    {
        name: 'Semana de Lactação',
        type: 'select',
        clearable: true,
        placeholder: 'Selecione',
        id: 'catLactationWeek',
        items: CAT_LACTATION_WEEK,
        default: null,
    },
];
const LIFE_STAGE_VALUES = {
    0: {
        "Neonatos": (w1, w2) => { return caloriesCalculation(w1, w2, 250); },
        "Até 50% do Peso Quando Adulto": (w1, w2) => { return caloriesCalculation(w1, w2, 210, 0.75); },
        "De 50 a 80% do Peso Quando Adulto": (w1, w2) => { return caloriesCalculation(w1, w2, 175, 0.75); },
        "80 a 100% do Peso Quando Adulto": (w1, w2) => { return caloriesCalculation(w1, w2, 140, 0.75); },
        "Perda de Peso": (w1, w2) => { return caloriesCalculation(w1, w2, 70, 0.75); },
        "Adulto Suscetível a Obesidade": (w1, w2) => { return caloriesCalculation(w1, w2, 90, 0.75); },
        "Sedentário ou Baixa Atividade (<1h/dia)": (w1, w2) => { return caloriesCalculation(w1, w2, 95, 0.75); },
        "Atividade Moderada de Baixo Impacto (1 – 3 h/dia)": (w1, w2) => { return caloriesCalculation(w1, w2, 110, 0.75); },
        "Atividade Moderada de Alto Impacto (1 – 3 h/dia)": (w1, w2) => { return caloriesCalculation(w1, w2, 125, 0.75); },
        "Alta Atividade (3 – 6 h/dia)": (w1, w2) => { return caloriesCalculation(w1, w2, 150, 0.75, 175); },
        "Alta Atividade sob Condições Extremas (ex: corridas de trenó)": (w1, w2) => { return caloriesCalculation(w1, w2, 860, 0.75, 1240); },
        "Dogue Alemão": (w1, w2) => { return caloriesCalculation(w1, w2, 200, 0.75); },
        "Terra-nova (Newfoundland)": (w1, w2) => { return caloriesCalculation(w1, w2, 105, 0.75); },
        "Primeiras 4 semanas de Gestação": (w1, w2) => { return caloriesCalculation(w1, w2, 132, 0.75); },
        "Últimas 5 semanas de Gestação": (w1, w2) => {
            const firstValue = (132 * Math.pow(w1, 0.75)) + (26 * w1);
            const secondValue = (132 * Math.pow((w2 || w1), 0.75)) + (26 * (w2 || w1));
            return concatText(firstValue, secondValue, 'kcal');
        },
        "Lactação": (w1, w2, dogPuppiesNumber, dogLactationWeek) => {
            const L = [0.75, 0.95, 1.1, 1.2][DOG_LACTATION_WEEK.indexOf(dogLactationWeek)];
            let firstValue = (145 * Math.pow(w1, 0.75));
            let secondValue = (145 * Math.pow((w2 || w1), 0.75));
            if (dogPuppiesNumber < 5) {
                firstValue = firstValue + (24 * dogPuppiesNumber * L * w1);
                secondValue = secondValue + (24 * dogPuppiesNumber * L * (w2 || w1));
            } else {
                firstValue = firstValue + ((96 + (12 * dogPuppiesNumber)) * (w1 * L));
                secondValue = secondValue + ((96 + (12 * dogPuppiesNumber)) * ((w2 || w1) * L));
            }
            return concatText(firstValue, secondValue, 'kcal');
        },
    },
    1: {
        "Até 4 meses de idade": (w1, w2) => { return caloriesCalculation(w1, w2, 200, 0.67, 250); },
        "4 a 9 meses de idade": (w1, w2) => { return caloriesCalculation(w1, w2, 175, 0.67, 200); },
        "9 a 12 meses de idade": (w1, w2) => { return caloriesCalculation(w1, w2, 150, 0.67); },
        "Castrado, Sedentário, Estrito Intradomiciliar": (w1, w2) => { return caloriesCalculation(w1, w2, 52, 0.67, 75); },
        "Gato Ativo": (w1, w2) => { return caloriesCalculation(w1, w2, 100, 0.67); },
        "Gestação": (w1, w2) => { return caloriesCalculation(w1, w2, 140, 0.67); },
        "Lactação": (w1, w2, catPuppiesNumber, catLactationWeek) => {
            const L = [0.9, 1.2, 1.1, 1, 0.8][CAT_LACTATION_WEEK.indexOf(catLactationWeek)];
            let constant = [18, 60, 70][CAT_PUPPIES_NUMBER.indexOf(catPuppiesNumber)];
            const firstValue = (100 * Math.pow(w1, 0.67)) + (constant * w1 * L);
            const secondValue = (100 * Math.pow((w2 || w1), 0.67)) + (constant * (w2 || w1) * L);
            return concatText(firstValue, secondValue, 'kcal');
        }
    }
}

const caloriesCalculation = function (w1, w2, c1, exponent = 1, c2 = null) {
    return concatText((c1 * Math.pow(w1, exponent)), ((c2 || c1) * Math.pow(w2 || w1, exponent)), 'kcal');
}
const concatText = function (arg1, arg2, suffix) {
    let response = _formatAndRoundNumber(arg1);
    if (arg1 != arg2) {
        response = `${response} a ${_formatAndRoundNumber(arg2)}`
    }
    return `${response} ${suffix}`;
}
function mounted() {
    changeVariableDisplay("dogPuppiesNumber");
    changeVariableDisplay("dogLactationWeek");
    changeVariableDisplay("catPuppiesNumber");
    changeVariableDisplay("catLactationWeek");
    changeVariableDisplay("catLifeStage");
}
function invalidLifeStageParameters(
    dogLifeStage, dogPuppiesNumber, dogLactationWeek,
    catLifeStage, catPuppiesNumber, catLactationWeek) {
    if (dogLifeStage) {
        return dogLifeStage == 'Lactação' && (!dogPuppiesNumber || !dogLactationWeek);
    } else if (catLifeStage) {
        return catLifeStage == 'Lactação' && (!catPuppiesNumber || !catLactationWeek);
    }
    return true;
}
function calculate({
    animal, weight, bodyScore,
    dogLifeStage, dogPuppiesNumber, dogLactationWeek,
    catLifeStage, catPuppiesNumber, catLactationWeek
}) {
    if (!bodyScore || invalidAnimal(animal) || !weight || !bodyScore ||
        invalidLifeStageParameters(
            dogLifeStage, dogPuppiesNumber, dogLactationWeek,
            catLifeStage, catPuppiesNumber, catLactationWeek
        )) {
        return;
    }
    weight = getNumber(weight);
    let response = { type: 'multiple', values: [] };
    const bodyScoreNumber = BODY_SCORE_ITEMS.indexOf(bodyScore) + 1;
    let factors = [];
    BODY_SCORE_FACTORS[animal].forEach(item => {
        if (item.score == bodyScoreNumber) {
            factors.push(item.factor);
        }
    });
    const w1 = factors[0] * weight;
    const w2 = factors.length > 1 ? factors[1] * weight : false;
    response.values.push({
        description: 'Peso ideal do paciente (Escore corporal 5)',
        value: concatText(w1, (w2 || w1), 'kg')
    });
    const lifeStage = animal == 0 ? dogLifeStage : catLifeStage;
    const puppiesNumber = animal == 0 ? dogPuppiesNumber : catPuppiesNumber;
    const lactationWeek = animal == 0 ? dogLactationWeek : catLactationWeek;
    response.values.push({
        description: 'Necessidade Energética Diária (Baseada no Peso Inserido)',
        value: LIFE_STAGE_VALUES[animal][lifeStage](weight, null, puppiesNumber, lactationWeek)
    });
    response.values.push({
        description: 'Necessidade Energética Diária (Baseada no Peso Ideal do Paciente | Escore 5)',
        value: LIFE_STAGE_VALUES[animal][lifeStage](w1, w2, puppiesNumber, lactationWeek)
    });

    return response;
}

export default {
    name: 'Calorias e Peso Ideal',
    id: 'e0352fcfe56742558ffe2d493d6075ec',
    classes: ['Cálculo Energético'],
    premium: true,
    mounted,
    variables: VARIABLES,
    calculate,
    responseLabel: "Resultados",
    sections: [
        {
            "description": "Objetivos da Calculadora ",
            "objects": [
                {
                    "description": "Necessidade Energética Diária",
                    "objects": [
                        {
                            "description": "O cálculo da necessidade energética diária, informa ao clínico, uma estimativa do ponto de partida em relação à quantidade de calorias diárias que um paciente deve receber.",
                            "objects": [
                                {
                                    "description": "Lembre que animais com características muito similares, podem apresentar diferentes necessidades energéticas, portanto, a quantidade de calorias deve ser personalizada e adaptada ao longo do acompanhamento clínico. "
                                }
                            ]
                        }
                    ]
                },
                {
                    "description": "Necessidade Energética | Baseada no Peso Real ou Peso Ideal ",
                    "objects": [
                        {
                            "objects": [
                                {
                                    "description": "Diante do supracitado, oferecemos as duas opções de necessidade energética diária, ficando a seu critério a escolha do que melhor se adequa ao seu paciente."
                                }
                            ],
                            "description": "Em seu guideline de 2020, a FEDIAF (European Pet Food Industry Federation), sugere que a necessidade energética seja baseada no peso corporal ótimo."
                        }
                    ]
                },
                {
                    "objects": [
                        {
                            "objects": [
                                {
                                    "description": "Lembre que o peso ideal é só uma sugestão, cabendo ao clínico, avaliar individualmente cada paciente de acordo com suas condições clínico-corporais."
                                }
                            ],
                            "description": "O cálculo do peso ideal se baseia na \"adequação\" do peso real do paciente ao seu escore corporal (Escala de 1 a 9)."
                        }
                    ],
                    "description": "Peso Ideal do Paciente (Escore 5)"
                }
            ]
        }
    ],
    references: [
        {
            "link": "Não se aplica",
            "magazine": "Guideline",
            "year": "2020",
            "name": "FEDIAD | Nutritional Guidelines for Complete and Complementary Pet Food for Cats and Dogs | September 2020",
            "level": "Não se aplica"
        },
        {
            "magazine": "Livro",
            "link": "Não se aplica.",
            "name": "Small Animal Clinical Nutrition | 5th Edition",
            "level": "Não se aplica.",
            "year": "2010"
        }
    ],
}
